<template>
    <div class="info-panel">
        <div class="info-panel-context">
            <div class="marker-row">
                <label for="name">{{ item.title }}</label>
            </div>
            <hr />
            <div class="marker-row">
                <table>
                    <tbody>
                        <tr>
                            <td style="width:102px;">
                                描述</td>
                            <td>
                                {{ item.description }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div class="info-panel-tools">
            <span class="icon-glyphicon-trash" title="删除" @click="removeObject"></span>
            <span class="icon-glyphicon-pencil" title="编辑属性" @click="editObject"></span>
            <!-- <span class="icon-glyphicon-camera" title="上传图片"></span>
            <span class="iconfont" title="更换图标"></span>
            <span class="icon-glyphicon-comment" title="动态"></span>
            <span class="icon-glyphicon-user" title="分派人员"></span> -->
        </div>
    </div>
</template>

<script>
import { useMapStore } from '@/stores/mapStore';

import { delDescription } from "@/api/Common";

import { ElMessage, ElMessageBox } from 'element-plus'

export default {
    name: 'InfoPanel',
    data() {
        return {
            mapStore: null,
            item: this.object.item,
        }
    },
    props: {
        object: {
            type: Object, // 对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        },
        layer: {
            type: Object, // 对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        }
    },
    mounted() {
        this.mapStore = useMapStore();

    },
    methods: {
        editObject() {
            this.mapStore.enableEditObject(this.object, this.item, this.layer);
        },
        removeObject() {
            var that = this;
            ElMessageBox.confirm(
                '确认删除：' + this.item.title + '?',
                '删除对象',
                {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    delDescription({ "ids": [this.item.id] }).then(res => {
                        that.layer.refreshDescription(that.item.code);
                    })
                })
                .catch(() => {

                })
        }


    }
}

</script>

<style scoped>
.info-panel-tools {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    margin-top: 10px;
}

.info-panel-tools span {
    float: right;
    cursor: pointer;
    margin-left: 5px;
}

.info-panel-context hr {
    margin-top: 2px;
    margin-bottom: 2px;
    border: 0;
    border-top: 1px solid #999;
}

.marker-row {
    font-size: 12px;
    margin-top: 5px;
}

.marker-row table {
    width: 100%;
    border-collapse: collapse;
}

.marker-row table td {
    border-top: none;
    border-bottom: 1px solid #fff;
    border-right: 1px solid #fff;
    background-color: #f5f7fa;
    color: #576d8b;
    padding: 8px;
    cursor: pointer;
}
</style>